import { DeleteRequest, GetRequest, PostRequest } from "./HttpService";

export const CreateManualReservation = async (manualReserveVM) => {
  return await PostRequest("/Reservation/manual-reservation", manualReserveVM);
};

export const getSettings = async () => {
  return await GetRequest("/AppSetting/get-settings");
};

export const updateSettings = async (settings) => {
  return await PostRequest("/AppSetting/update-settings", settings);
};

export const updateWorkingDays = async (workingDays) => {
  return await PostRequest("/AppSetting/update-working-days", workingDays);
};

export const getWorkingDays = async () => {
  return await GetRequest("/AppSetting/working-days");
};

export const getExceptionDays = async () => {
  return await GetRequest("/AppSetting/exception-days");
};

export const addExceptionDay = async (exceprionDay) => {
  return await PostRequest("/AppSetting/add-exception-days", exceprionDay);
};

export const deleteExceptionDay = async (id) => {
  const response = await DeleteRequest("/AppSetting/delete-exception-days", id);
  return response.data;
};

export const GetUploadPermissions = async () => {
  return await GetRequest("/AppSetting/get-upload-permissions");
};
